import * as React from 'react';
import { PriceType } from "../../../classes/price-type"
import Toggle from "../../../common/toggle/toggle"
import CheckboxGroup from "../../../common/checkbox/checkbox-group"
import { SeatingOption, IOptionGroup, IOption } from '../../../classes/seating-option';
import { sortPriceTypes } from '../../../helpers/price-type-helpers';
import isEqual from 'react-fast-compare';

interface IPriceTypeFilterProps {
    priceTypes: Array<PriceType>
    onPriceTypeToggle: (selectedOptions: IOption[]) => void;
    selectedPriceTypeIds: Array<string>;
    description: string;
    allTicketsText: string;
    singleFilter: boolean;
    legend: string;
}

export default class PriceTypeFilter extends React.Component<IPriceTypeFilterProps, {}> {
    constructor(props: IPriceTypeFilterProps) {
        super(props);
    }

    getSortedPriceTypes(pts: Array<PriceType>) {
        return sortPriceTypes(pts);
    }

    shouldComponentUpdate(nextProps: IPriceTypeFilterProps) {
        return this.props.description != nextProps.description
            || this.props.allTicketsText != nextProps.allTicketsText
            || !isEqual(
                { priceTypes: this.props.priceTypes, selectedPriceTypeIds: this.props.selectedPriceTypeIds },
                { priceTypes: nextProps.priceTypes, selectedPriceTypeIds: nextProps.selectedPriceTypeIds });
    }

    render() {
        const priceTypeOptions = this.getSortedPriceTypes(this.props.priceTypes).map(priceType => {
            let opt: IOption = {
                id: priceType.priceTypeId.toString(),
                name: priceType.title,
                selected: this.props.selectedPriceTypeIds.indexOf(priceType.priceTypeId.toString()) >= 0
            };
            return opt;
        });

        return (
            <fieldset className="price-type-filter-list">
                <legend className="visually-hidden">{this.props.legend}</legend>
                {
                    <CheckboxGroup group={{
                        options: priceTypeOptions,
                        name: "priceTypeFilter"
                    } as IOptionGroup}
                        allText={this.props.allTicketsText}
                        showAllOption={this.props.singleFilter}
                        selectedOptions={priceTypeOptions.filter(option => this.props.selectedPriceTypeIds.indexOf(option.id) >= 0)}
                        stateChangeFunction={this.props.onPriceTypeToggle} id={null} />
                }
            </fieldset>
        )
    }
}